import { render, staticRenderFns } from "./ManageCompany.vue?vue&type=template&id=6a217200&"
import script from "./ManageCompany.vue?vue&type=script&lang=js&"
export * from "./ManageCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports